import { NewsRelevanceEnum } from "~/types/newsArticle";

export const SKELETON_CARD_HEIGHT = 88;

export const RELEVANCE_LABEL_COLOR: Record<
  NewsRelevanceEnum,
  "success" | "warning" | "info"
> = {
  [NewsRelevanceEnum.HIGH]: "success",
  [NewsRelevanceEnum.MEDIUM]: "warning",
  [NewsRelevanceEnum.LOW]: "info",
};
